import gql from 'graphql-tag';

export const headerFooterQuery = gql`
  query HeaderFooterContext($input: HeaderFooterContextInput) {
    headerFooterContext {
      identityContext {
        act(input: $input) {
          operatorEmail
          csToggleHref
          isCsView
        }
        email
      }
      advertiser {
        billingId
        hasMultipleAccounts
        isActivationPending
        isAgency
        name
        permissionOptions {
          canCreateJobs
          canManageBrand
          canManageUsers
          canPayInvoices
          canViewInvoiceHistory
          canViewManagerReports
          canManageCompanyProfile
          canViewInsightsRoleReport
          canClaimCompanyProfile
          canViewPremiumTalentSearch
        }
        showOnCreditHoldMessage
        switchAccountsHref
      }
      user {
        name
        firstName
        id
      }
    }
    currentAdvertiser {
      ... on CurrentAdvertiserContext {
        __typename
        seekId
      }
      ... on Error {
        __typename
        message
      }
    }
  }
`;
